<template>
		<span>
			<a href="javascript:void(0)" @click="openModal" :class="{ 'uk-navbar-item uk-padding-small' : navBarItem }">
				<span class="material-symbols-outlined">search</span> 
				<span class="uk-visible@s">{{ text }}</span> 
			</a>
			<div id="search-modal" class="uk-flex-top" uk-modal>
				<div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
					<button class="uk-modal-close-default" type="button" uk-close></button>
					<h4 class="uk-modal-title">
						<i class="material-symbols-outlined">search</i> {{ text }}
					</h4>
					<form :action="action" ref="searchForm">
						<input v-model="searchTerm" name="q" ref="searchInput" class="uk-input" type="text" placeholder="Vul een zoekterm in..." required>
						<button class="uk-button uk-button-primary uk-margin-top">Go!</button>
					</form>
				</div>
			</div>
	</span>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';

export default {
	name: 'SearchModal',

	props: {
		action: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: false,
			default: "Zoeken"
		},
		navBarItem: {
			type: Boolean,
			required: false,
			default: false
		}		
	},

	setup() {
		const searchTerm = ref('');
		const searchInput = ref(null);
		const searchForm = ref(null);

		const openModal = () => {
			UIkit.modal('#search-modal').show();
			nextTick(() => {
				setTimeout(function() {
					searchInput.value.focus();
				},300);
			});
		};

		const search = () => {
			UIkit.modal('#search-modal').hide();
		};

		return {
			searchTerm,
			search,
			openModal,
			searchInput
		};
	},
};
</script>

<style scoped>
/* Add any required CSS here */
</style>
